import Navbar from "../components/Navbar";
import "../styles/Home.css";

export default function Creations() {
  return (
    <>
     

      {/* Page Header */}

      <section className="section">
        <div className="container" style={{textAlign:"center"}}>

          <h1 style={{fontSize:"40px",marginBottom:"15px"}}>
            Our Recent works
          </h1>

          <p style={{maxWidth:"700px",margin:"auto",color:"#555"}}>
            Products and client solutions built with clarity, performance,
            and real-world usability.
          </p>

        </div>
      </section>


      {/* Projects */}

      <section className="section">
        <div className="container">

          <div className="services">

            {/* SK Hair Clinic */}

            <div className="service-card">

              <h3>SK Hair Clinic</h3>

              <p style={{marginBottom:"10px",color:"#777"}}>
                Hair Transplant & Medical Website — Noida / Delhi
              </p>

              <p>
                A professional, conversion-focused website designed for a
                hair transplant clinic, emphasizing trust and patient
                confidence through structured content and clean medical
                branding.
              </p>

              <ul style={{marginTop:"15px",paddingLeft:"18px",color:"#555"}}>
                <li>Modern medical-grade branding</li>
                <li>Lead-focused landing page structure</li>
                <li>Clear service presentation</li>
                <li>Responsive performance UI</li>
              </ul>

              <div style={{marginTop:"20px"}}>
                <a className="btn-primary" href="https://skhairstudio.com/">
                  Website
                </a>
              </div>

            </div>

<div className="service-card">

  <h3>Feoric</h3>

  <p style={{marginBottom:"10px",color:"#777"}}>
    Premium Fashion E-commerce Platform
  </p>

  <p>
    Feoric is a modern clothing e-commerce store based in Uttar Pradesh, India,
    built to deliver high-quality fashion products with a smooth and reliable
    online shopping experience. The platform focuses on clean design,
    fast performance, and a customer-first approach to digital retail.
  </p>

  <ul style={{marginTop:"15px",paddingLeft:"18px",color:"#555"}}>
    <li>Fully responsive online clothing store</li>
    <li>Secure checkout & payment integration</li>
    <li>Optimized for mobile shopping</li>
    <li>Designed for scalable growth</li>
  </ul>

  <div style={{marginTop:"20px"}}>
    <a
      className="btn-primary"
      href="https://feoric.in"
      target="_blank"
      rel="noreferrer"
    >
      Website
    </a>
  </div>

</div>
<div className="service-card">

  <h3>  vellanos
</h3>

  <p style={{marginBottom:"10px",color:"#777"}}>
    Premium shopify E-commerce Platform
  </p>

  <p>

  </p>

  <ul style={{marginTop:"15px",paddingLeft:"18px",color:"#555"}}>
    <li>Fully responsive shopify store</li>
    <li>Secure checkout & payment integration</li>
    <li>Optimized for mobile shopping</li>
    <li>Designed for scalable growth</li>
  </ul>

  <div style={{marginTop:"20px"}}>
    <a
      className="btn-primary"
      href="https://vellanos.shop/"
      target="_blank"
      rel="noreferrer"
    >
      Website
    </a>
  </div>

</div>
  {/* Mongi Cake Shop */}

            <div className="service-card">

              <h3>Mongi’s Cake Shop</h3>

              <p style={{marginBottom:"10px",color:"#777"}}>
                Local Bakery Business Website — Raipur
              </p>

              <p>
                A clean modern website built for a local cake shop to showcase
                products clearly and engage nearby customers with a
                mobile-first experience.
              </p>

              <ul style={{marginTop:"15px",paddingLeft:"18px",color:"#555"}}>
                <li>Product-focused visual layout</li>
                <li>Mobile-friendly design</li>
                <li>Fast static deployment</li>
                <li>Simple maintenance structure</li>
              </ul>

              <div style={{marginTop:"20px"}}>
                <a className="btn-primary" href="https://mongnis.shop/">
                  Website
                </a>
              </div>

            </div>


            {/* NeuralCrypto */}

            <div className="service-card">

              <h3>NeuralCrypto</h3>

              <p style={{marginBottom:"10px",color:"#777"}}>
                Crypto Signal & Research Platform
              </p>

              <p>
                NeuralCrypto is a crypto signal platform focused on market
                structure, price action, and disciplined strategy execution
                built from extensive Bitcoin backtesting.
              </p>

              <ul style={{marginTop:"15px",paddingLeft:"18px",color:"#555"}}>
                <li>Custom strategy signal engine</li>
                <li>Multi-timeframe market analysis</li>
                <li>100K+ organic Instagram reach</li>
                <li>Educational & research-driven</li>
              </ul>

              <div style={{marginTop:"20px",display:"flex",gap:"10px"}}>
                <a className="btn-primary" href="https://neuralcrypto.space/">Website</a>
              
              </div>

            </div>


            {/* Zaroni */}

            <div className="service-card">

              <h3>Zaroni</h3>

              <p style={{marginBottom:"10px",color:"#777"}}>
                Modern E-commerce Platform
              </p>

              <p>
                Zaroni is a scalable e-commerce platform designed to support
                curated everyday products with smooth customer journeys
                across multiple regions.
              </p>

              <ul style={{marginTop:"15px",paddingLeft:"18px",color:"#555"}}>
                <li>Complete e-commerce workflow</li>
                <li>Optimized checkout experience</li>
                <li>India launch completed</li>
                <li>International expansion roadmap</li>
              </ul>

              <div style={{marginTop:"20px"}}>
                <a className="btn-primary" href="https://www.zaroni.store/">
                  Website
                </a>
              </div>

            </div>


          
        
{/* More Projects Animation */}

<div className="more-projects">

<h2>And much more...</h2>

<div className="more-grid">

<div>⚡ Internal Automation Tools</div>
<div>🤖 AI Experiments</div>
<div>📊 Data Platforms</div>
<div>📱 Mobile Apps</div>
<div>🛒 E-commerce Stores</div>
<div>🔧 Custom Client Systems</div>

</div>

</div>
          </div>

        </div>
    
{/* ===== TESTIMONIALS ===== */}

<section className="testimonials-section">
  <div className="container">

    <div className="testimonials-header">
      <h2>Client Testimonials</h2>
      <p>
        Trusted by clients for web, Shopify, and Salesforce development.
      </p>
    </div>

    <div className="testimonials-grid">

      {/* 1 */}
      <div className="testimonial-card">
   
        <p>
          "They understood our requirements clearly and delivered 
a modern, responsive website. Communication was smooth 
— exactly what we needed."
        </p>
        <div className="client">
          <strong>SK Studio</strong>
          <span>Owner</span>
        </div>
      </div>

      {/* 2 */}
      <div className="testimonial-card">
      
        <p>
"Built exactly as we wanted — fast performance, clean design, 
and works perfectly on all devices. Reliable support throughout."
        </p>
        <div className="client">
          <strong>Feoric.in</strong>
          <span>Owner</span>
        </div>
      </div>

      {/* 3 */}
      <div className="testimonial-card">
      
        <p>
"Shopify store setup and customization done with great attention 
to detail. Completed on time with excellent technical knowledge."
        </p>
        <div className="client">
          <strong>Zaroni</strong>
          <span>Founder</span>
        </div>
      </div>

      {/* 4 */}
      <div className="testimonial-card">
      
        <p>
"Project delivered on schedule with excellent quality. 
Professional, responsive, and genuinely easy to work with."
        </p>
        <div className="client">
          <strong>Mongnis</strong>
          <span>Owner</span>
        </div>
      </div>

    </div>
  </div>
</section>

      {/* Footer */}

      <footer className="footer">
        <div className="container">

          <p>© 2024 AlmondSoftware. All rights reserved.</p>

          <p style={{marginTop:"10px"}}>
            Engineering digital products with intelligence
          </p>

 

        </div>
      </footer>
  </section>
    </>
  );
}